import ScoreGradeRepositoryInterface, { ScoreGradeInterface } from '@/services/QA/scoreGrade/interfaces';
import { AxiosInstance } from 'axios';

export default class ScoreGradeRepository implements ScoreGradeRepositoryInterface {
  constructor(
    private axios: AxiosInstance,
  ) {
  }

  public async createScoreGrade(data: Partial<ScoreGradeInterface>): Promise<ScoreGradeInterface> {
    const res = await this.axios.post('/qa-controller/scoreGrades', data);

    return res.data;
  }

  public async editScoreGrade(scoreGradeId: number, scoreGradeData: Partial<ScoreGradeInterface>): Promise<void> {
    await this.axios.patch(`/qa-controller/scoreGrades/${scoreGradeId}`, scoreGradeData);
  }

  public async getOneById(scoreGradeId: number): Promise<ScoreGradeInterface> {
    const res = await this.axios.get(`/qa-controller/scoreGrades/${scoreGradeId}`);

    return res.data;
  }

  public async getAllScoreGrades(): Promise<ScoreGradeInterface[]> {
    const res = await this.axios.get('/qa-controller/scoreGrades');

    return res.data;
  }

}
